import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
import './Map.css';
import RussiaSvg from './RussiaSvg';

interface RegionData {
  id: string;
  name: string;
  flag?: string;
}

interface RusMapProps {
  onRegionClick?: (region: string) => void;
  selectedRegions?: string[];
  examData?: {
    region_company?: string;
    exam_result?: string;
  }[];
  className?: string;
}

export interface RusMapRef {
  resetMap: () => void;
  highlightRegion: (regionName: string) => void;
}

const regions: RegionData[] = [
    { id: "RU-ALT", name: "Алтайский край" },
    { id: "RU-AMU", name: "Амурская обл." }, //нет такого 
    { id: "RU-ARK", name: "Архангельская обл." }, //только в адресе 
    { id: "RU-AST", name: "Астраханская обл." },
    { id: "RU-BEL", name: "Белгородская обл." },
    { id: "RU-BRY", name: "Брянская обл." },
    { id: "RU-VLA", name: "Владимирская обл." },
    { id: "RU-VGG", name: "Волгоградская обл." },
    { id: "RU-VLG", name: "Вологодская обл." },
    { id: "RU-YEV", name: "Еврейская автономная обл." }, //нет такого
    { id: "RU-ZAB", name: "Забайкальский край" },//нет такого
    { id: "RU-IVA", name: "Ивановская обл." },
    { id: "RU-IRK", name: "Иркутская обл." },
    { id: "RU-KB", name: "Кабардино-Балкарская республика" },//нет такого
    { id: "RU-KGD", name: "Калининградская обл." },
    { id: "RU-KLU", name: "Калужская обл." },
    { id: "RU-KAM", name: "Камчатский край" },//нет такого
    { id: "RU-KC", name: "Карачаевая-Черкесская республика" },//нет такого
    { id: "RU-KEM", name: "Кемеровская обл." },//нет такого
    { id: "RU-KIR", name: "Кировская обл." },
    { id: "RU-KOS", name: "Костромская обл." },//нет такого
    { id: "RU-KDA", name: "Краснодарский край" },
    { id: "RU-KYA", name: "Красноярский край" },
    { id: "RU-KGN", name: "Курганская обл." },
    { id: "RU-KRS", name: "Курская обл." },
    { id: "RU-LEN", name: "Ленинградская обл." },
    { id: "RU-LIP", name: "Липецкая обл." },//нет такого
    { id: "RU-MAG", name: "Магаданская обл." },//нет такого
    { id: "RU-MOW", name: "Москва" },
    { id: "RU-MOS", name: "Московская обл." },
    { id: "RU-MUR", name: "Мурманская обл." },
    { id: "RU-NEN", name: "Ненецкий АО" },//нет такого
    { id: "RU-NIZ", name: "Нижегородская обл." },//нет такого
    { id: "RU-NGR", name: "Новгородская обл." },
    { id: "RU-NVS", name: "Новосибирская обл." },
    { id: "RU-OMS", name: "Омская обл." },
    { id: "RU-ORE", name: "Оренбургская обл." },
    { id: "RU-ORL", name: "Орловская обл." },
    { id: "RU-PNZ", name: "Пензенская обл." },//нет такого
    { id: "RU-PER", name: "Пермский край" },
    { id: "RU-PRI", name: "Приморский край" },
    { id: "RU-AD", name: "Республика Адыгея" },
    { id: "RU-AL", name: "Алтайский край" },
    { id: "RU-BA", name: "Республика Башкортостан" },
    { id: "RU-BU", name: "Республика Бурятия" },
    { id: "RU-DA", name: "Республика Дагестан" },
    { id: "RU-IN", name: "Республика Ингушетия" },//нет такого
    { id: "RU-KL", name: "Республика Калмыкия" },//нет такого
    { id: "RU-KR", name: "Республика Карелия" },//нет такого
    { id: "RU-KO", name: "Республика Коми" },//нет такого
    { id: "RU-CR", name: "Республика Крым" },
    { id: "RU-ME", name: "Республика Марий-Эл" },
    { id: "RU-MO", name: "Республика Мордовия" },
    { id: "RU-SA", name: "Республика Саха(Якутия)" },
    { id: "RU-SE", name: "Республика Северная Осетия" },//нет такого
    { id: "RU-TA", name: "Республика Татарстан" },
    { id: "RU-TY", name: "Республика Тыва" },//нет такого
    { id: "RU-KK", name: "Республика Хакасия" },//нет такого
    { id: "RU-ROS", name: "Ростовская обл." },
    { id: "RU-RYA", name: "Рязанская обл." },
    { id: "RU-SAM", name: "Самарская обл." },
    { id: "RU-SPE", name: "Санкт-Петербург" },
    { id: "RU-SAR", name: "Саратовская обл." },
    { id: "RU-SAK", name: "Сахалинская обл." },//нет такого
    { id: "RU-SVE", name: "Свердловская обл." },
    { id: "RU-SEV", name: "Севастополь" },
    { id: "RU-SMO", name: "Смоленская обл." },
    { id: "RU-VOR", name: "Ставропольский край" },
    { id: "RU-STA", name: "Ставропольский край" },
    { id: "RU-TAM", name: "Тамбовская обл." },
    { id: "RU-TVE", name: "Тверская обл." },
    { id: "RU-TOM", name: "Томская обл." },
    { id: "RU-TUL", name: "Тульская обл." },
    { id: "RU-TYU", name: "Тюменская обл." },
    { id: "RU-UD", name: "Республика Удмуртия" },
    { id: "RU-ULY", name: "Ульяновская обл." },
    { id: "RU-KHA", name: "Хабаровский край" },
    { id: "RU-KHM", name: "Ханты-Мансийский АО" },//нет такого
    { id: "RU-CHE", name: "Челябинская обл." },
    { id: "RU-CE", name: "Чеченская республика" },
    { id: "RU-CU", name: "Республика Чувашия" },
    { id: "RU-CHU", name: "Чукотский АО" },//нет такого
    { id: "RU-YAN", name: "Ямало-Ненецкий АО" },//нет такого
    { id: "RU-YAR", name: "Ярославская обл." },
    { id: "RU-PSK", name: "Псковская обл." }
];

const RusMap = forwardRef<RusMapRef, RusMapProps>(({ onRegionClick, selectedRegions, examData, className }, ref) => {
  const [hoveredRegion, setHoveredRegion] = useState<RegionData | null>(null);
  const [localSelectedRegions, setLocalSelectedRegions] = useState<string[]>([]);
  const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0 });
  const TOOLTIP_OFFSET = { x: 16, y: 12 };
  const [isZoomed, setIsZoomed] = useState(false);
  const [scale, setScale] = useState(1);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [isDragging, setIsDragging] = useState(false);
  const [dragStart, setDragStart] = useState({ x: 0, y: 0 });
  const mapRef = useRef<HTMLDivElement>(null);
  const mapWrapperRef = useRef<HTMLDivElement>(null);
  
  const normalizeRegion = (str: string): string => {
    if (!str) return '';
    return str
      .toLowerCase()
      .replace(/\./g, '')
      .replace(/\b(область|обл|край|республика|город|г|ао|автономный округ|респ)\b/g, '')
      .replace(/\(|\)/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  };

  const DEFAULT_REGION_FILL = '#e0e0e0';

  useEffect(() => {
    if (selectedRegions) {
      setLocalSelectedRegions(selectedRegions);
    }
  }, [selectedRegions]);
  
  const calculateRegionColor = (_regionName: string) => {
    return DEFAULT_REGION_FILL;
  };
  
  const getRegionStats = (regionName: string) => {
    if (!examData || !regionName) return null;

    const normalizedName = normalizeRegion(regionName);
    const regionExams = examData.filter(exam => {
      const examRegion = normalizeRegion(exam.region_company || '');
      return examRegion && normalizedName && examRegion === normalizedName;
    });

    if (regionExams.length === 0) return null;

    const totalExams = regionExams.length;
    const violations = regionExams.filter(exam => 
      exam.exam_result === 'Не соответствует НД (фальсификат)' || 
      exam.exam_result === 'Не соответствует НД (брак)'
    ).length;
    const compliant = regionExams.filter(exam => 
      exam.exam_result === 'Соответствует НД'
    ).length;
    const noData = regionExams.filter(exam => 
      exam.exam_result === 'нет данных'
    ).length;

    return {
      totalExams,
      violations,
      compliant,
      noData
    };
  };
  
  useImperativeHandle(ref, () => ({
    resetMap: () => {
      setLocalSelectedRegions([]);
      if (mapRef.current) {
        const paths = mapRef.current.querySelectorAll('path');
        paths.forEach(path => {
          path.style.fill = DEFAULT_REGION_FILL;
        });
      }
    },
    highlightRegion: (regionName: string) => {
      const region = regions.find(r => r.name.toLowerCase() === regionName.toLowerCase());
      if (region && mapRef.current) {
        const path = mapRef.current.querySelector(`path#${region.id}`);
        if (path) {
          (path as SVGPathElement).style.fill = DEFAULT_REGION_FILL;
          setLocalSelectedRegions(prev => [...prev, region.name]);
        }
      }
    }
  }));
  
  useEffect(() => {
    if (mapRef.current) {
      const paths = mapRef.current.querySelectorAll('path');
      paths.forEach(path => {
        const regionId = path.id;
        const region = regions.find(r => r.id === regionId);
        if (region) {
          const newColor = DEFAULT_REGION_FILL;
          if (newColor !== path.style.fill) {
            path.style.fill = newColor;
          }
        }
      });
    }
  }, [localSelectedRegions]);

  useEffect(() => {
    const container = mapRef.current;
    if (!container) return;
  
    const handleClick = (event: MouseEvent) => {
      const path = event.target as SVGPathElement;
      if (path.tagName.toLowerCase() === 'path') {
        const regionId = path.id;
        if (regionId) {
          const region = regions.find(r => r.id === regionId);
          if (region && onRegionClick) {
            const isSelected = localSelectedRegions.some(selectedRegion => 
              selectedRegion.toLowerCase() === region.name.toLowerCase()
            );
            
            if (isSelected) {
              setLocalSelectedRegions(prev => 
                prev.filter(r => r.toLowerCase() !== region.name.toLowerCase())
              );
            } else {
              setLocalSelectedRegions(prev => [...prev, region.name]);
            }
            path.style.fill = calculateRegionColor(region.name);
            onRegionClick(region.name);
          }
        }
      }
    };

    const handleMouseEnter = (event: MouseEvent) => {
      const path = event.target as SVGPathElement;
      if (path.tagName.toLowerCase() === 'path') {
        const regionId = path.id;
        const region = regions.find(r => r.id === regionId);
        if (region) {
          setHoveredRegion(region);
          setTooltipPosition({ x: event.clientX + TOOLTIP_OFFSET.x, y: event.clientY + TOOLTIP_OFFSET.y });
          const isSelected = localSelectedRegions.some(selectedRegion => 
            selectedRegion.toLowerCase() === region.name.toLowerCase()
          );
          if (!isSelected) {
            path.style.fill = 'transparent';
          }
        }
      }
    };

    const handleMouseMove = (event: MouseEvent) => {
      if (hoveredRegion) {
        let nextX = event.clientX + TOOLTIP_OFFSET.x;
        let nextY = event.clientY + TOOLTIP_OFFSET.y;

        const margin = 8;
        const tooltipEl = document.querySelector('.region-tooltip') as HTMLElement | null;
        const tooltipWidth = tooltipEl?.offsetWidth ?? 240;
        const tooltipHeight = tooltipEl?.offsetHeight ?? 120;

        if (nextX + tooltipWidth + margin > window.innerWidth) {
          nextX = event.clientX - tooltipWidth - TOOLTIP_OFFSET.x;
        }
        if (nextY + tooltipHeight + margin > window.innerHeight) {
          nextY = event.clientY - tooltipHeight - TOOLTIP_OFFSET.y;
        }

        nextX = Math.max(margin, Math.min(nextX, window.innerWidth - margin - tooltipWidth));
        nextY = Math.max(margin, Math.min(nextY, window.innerHeight - margin - tooltipHeight));

        setTooltipPosition({ x: nextX, y: nextY });
      }
    };

    const handleMouseLeave = (event: MouseEvent) => {
      const path = event.target as SVGPathElement;
      if (path.tagName.toLowerCase() === 'path') {
        setHoveredRegion(null);
        path.style.fill = DEFAULT_REGION_FILL;
      }
    };

    container.addEventListener('click', handleClick);
    container.addEventListener('mouseenter', handleMouseEnter, true);
    container.addEventListener('mousemove', handleMouseMove);
    container.addEventListener('mouseleave', handleMouseLeave, true);
  
    return () => {
      container.removeEventListener('click', handleClick);
      container.removeEventListener('mouseenter', handleMouseEnter, true);
      container.removeEventListener('mousemove', handleMouseMove);
      container.removeEventListener('mouseleave', handleMouseLeave, true);
    };
  }, [onRegionClick, localSelectedRegions, examData, hoveredRegion]);

  const handleZoomIn = () => {
    setScale(prev => Math.min(prev + 0.5, 3));
  };

  const handleZoomOut = () => {
    setScale(prev => Math.max(prev - 0.5, 1));
  };

  const handleResetZoom = () => {
    setScale(1);
    setPosition({ x: 0, y: 0 });
  };

  const handleMouseDown = (e: React.MouseEvent) => {
    if (scale > 1) {
      setIsDragging(true);
      setDragStart({
        x: e.clientX - position.x,
        y: e.clientY - position.y
      });
    }
  };

  const handleMouseMove = (e: React.MouseEvent) => {
    if (isDragging && scale > 1) {
      setPosition({
        x: e.clientX - dragStart.x,
        y: e.clientY - dragStart.y
      });
    }
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  const handleWheel = (e: React.WheelEvent) => {
    if (e.ctrlKey) {
      e.preventDefault();
      const delta = e.deltaY > 0 ? -0.1 : 0.1;
      setScale(prev => Math.min(Math.max(prev + delta, 1), 3));
    }
  };

  return (
    <div className={`map-container${className ? ' ' + className : ''}`} ref={mapRef}>
      <div className="map-controls">
        <button onClick={handleZoomIn} className="zoom-button">+</button>
        <button onClick={handleZoomOut} className="zoom-button">-</button>
        <button onClick={handleResetZoom} className="zoom-button">⟲</button>
      </div>
      <div 
        className="map-wrapper"
        ref={mapWrapperRef}
        style={{
          transform: `scale(${scale}) translate(${position.x}px, ${position.y}px)`,
          cursor: scale > 1 ? (isDragging ? 'grabbing' : 'grab') : 'default'
        }}
        onMouseDown={handleMouseDown}
        onMouseMove={handleMouseMove}
        onMouseUp={handleMouseUp}
        onMouseLeave={handleMouseUp}
        onWheel={handleWheel}
      >
        <div className="map">
          <RussiaSvg />
        </div>
      </div>
      {hoveredRegion && (
        <div 
          className="region-tooltip" 
          style={{
            left: `${tooltipPosition.x}px`,
            top: `${tooltipPosition.y}px`
          }}
        >
          <div className="region-name">{hoveredRegion.name}</div>
          {examData && (
            <div className="region-stats">
              {(() => {
                const stats = getRegionStats(hoveredRegion.name);
                if (!stats) return null;
                return (
                  <>
                    <div>Всего испытаний: {stats.totalExams}</div>
                    <div>Соответствует НД: {stats.compliant}</div>
                    <div>Не соответствует НД: {stats.violations}</div>
                    <div>Нет данных: {stats.noData}</div>
                  </>
                );
              })()}
            </div>
          )}
        </div>
      )}
    </div>
  );
});

export default RusMap;